import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconFolderCalendar: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        opacity="0.4"
        d="M14.0706 4.2627H11.618C11.0071 4.26673 10.427 3.99495 10.0398 3.52325L9.23216 2.40668C8.85147 1.93084 8.27141 1.65778 7.66133 1.66723H5.9275C2.81548 1.66723 1.667 3.49367 1.667 6.59936V9.95646C1.66313 10.3256 18.33 10.3252 18.3311 9.95646V8.98038C18.3459 5.8747 17.2271 4.2627 14.0706 4.2627Z"
        fill="#200E32"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3604 5.45347C17.627 5.76521 17.8331 6.1238 17.968 6.51089C18.2335 7.30646 18.3564 8.1425 18.3311 8.98065V13.3582C18.33 13.7269 18.3028 14.0951 18.2496 14.46C18.1483 15.1039 17.9217 15.7219 17.5827 16.279C17.4269 16.5481 17.2377 16.7966 17.0196 17.0185C16.0322 17.9246 14.7211 18.3963 13.3815 18.3273H6.60917C5.2674 18.3958 3.95417 17.9243 2.96367 17.0185C2.74816 16.7961 2.56146 16.5477 2.40795 16.279C2.07095 15.7223 1.84923 15.1037 1.75591 14.46C1.69657 14.0957 1.66683 13.7272 1.66699 13.3582V8.98065C1.66685 8.61505 1.68664 8.24971 1.72627 7.88626C1.7346 7.8225 1.74711 7.75977 1.75948 7.69769C1.7801 7.5942 1.80037 7.49252 1.80037 7.39083C1.87558 6.95223 2.01279 6.5265 2.20789 6.12637C2.78584 4.89149 3.97137 4.26296 5.91267 4.26296H14.0632C15.1505 4.17887 16.2297 4.5062 17.0863 5.17988C17.1849 5.26353 17.2766 5.35503 17.3604 5.45347ZM5.80894 12.9515H14.1966H14.2114C14.3954 12.9595 14.575 12.8936 14.71 12.7686C14.8451 12.6435 14.9243 12.4697 14.9301 12.286C14.9405 12.1245 14.8873 11.9653 14.7819 11.8423C14.6606 11.6771 14.4685 11.5784 14.2632 11.5761H5.80894C5.42836 11.5761 5.11985 11.884 5.11985 12.2638C5.11985 12.6436 5.42836 12.9515 5.80894 12.9515Z"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconFolderCalendar;
